


if ($(window).width() <= 900) {
    $('.custom-multicolumn-slider').addClass('swiper');
    $('.custom-multicolumn-slider-wrap').addClass('swiper-wrapper');
    $('.custom-multicolumn-item').addClass('swiper-slide');

    var swiper = new Swiper(".custom-multicolumn-slider", {
      slidesPerView: 2,
      spaceBetween: 15,
      pagination: {
        el: ".swiper-pagination",
      },
    }); 
}


// $(document).ready(function(){
//     $('.image-zoom')
//     .wrap('<span style="display:inline-block"></span>')
//     .css('display', 'block')
//     .parent()
//     .zoom({
//       url: $(this).find('img').attr('data-zoom')
//     });
//   });


$(document).ready(function(){
  $('.collection-product-options-item:nth-child(2) label:nth-child(3) span').css('display','block');
  $('.collection-product-options-item').click(function(){
    let a = $(this).find('label:nth-child(3) span');
      $('.collection-product-options-item label:nth-child(3) span').css('display','none');
      $(a).css('display','block');
  });

  $('variant-radios fieldset').each(function(){
    let b = $(this).find('.form__label').text();
    console.log(b);
    if(b === 'Color'){
      let c = $(this).closest('fieldset');
      $(c).addClass('custom-option-label-color-wrap');
      $(c).find('label').addClass('custom-option-label-color');
    }
  })

  


});


/*****/

$(()=>{
 let optVal = $('.collection-product-options-item input').val();
 $('.variant-media-switch .media-img[data-'+ optVal +']').css('opacity','1'); 
 $('.collection-product-options-item').click(function(){
       let colorVal = $(this).find('input').val();
       console.log(colorVal);
      $('.variant-media-switch .media-img').css('opacity','0'); 
      $('.variant-media-switch .media-img[data-'+ colorVal +']').css('opacity','1'); 
 });
  
});



$(()=>{
    console.log($('.image-container').length);
   document.querySelectorAll('.image-container').forEach(elem =>{
        let x,y,width,height;
  
        elem.onmouseenter = () =>{
              const size = elem.getBoundingClientRect();
  
          x = size.x;
          y = size.y;
  
          width = size.width;
          height = size.height;
          
        };
        
        elem.onmousemove = e =>{
          const horizontal = (e.clientX - x) / width * 100;
          const vertical = (e.clientY - y) / height * 100;
  
          elem.style.setProperty('--x',horizontal + '%' );
          elem.style.setProperty('--y',vertical  + '%' );
        }
    });
});
$(()=>{
  $('.collection-product-options-item').click(function(){
   
    $(this).closest('.grid__item').find('.color-name').text($(this).find('.swatcher-color-input').val());
  })
  $('.grid__item input:checked ').val();
  $('.grid__item').each(function(){
      let v = $(this).find('input:checked').val();
      $(this).find('.color-name').text(v);
  });
})